import { getCart, updateCartCount } from "../helpers";

var sharedTimeout;
var popup = document.querySelector("#CartPopup");
var textWrapper = document.querySelector(".cart-popup__text");
export const showCartPopup = (lineItem, productString = null) => {
  if (!textWrapper) return;
  if (textWrapper) textWrapper.innerHTML = productString;

  popup.classList.add("shown");
  if (sharedTimeout) clearTimeout(sharedTimeout);
  sharedTimeout = setTimeout(() => {
    popup.classList.remove("shown");
  }, 3000);
};

export const initCartPopup = () => {
  if (!popup) return;
  window.addEventListener("CartPopup:show", async (e) => {
    getCart((cartData) => {
      if (typeof theme?.ShippingNotice?.calcFreeshippingDiff === "function")
        theme.ShippingNotice.calcFreeshippingDiff(cartData);
    }, null);
    await updateCartCount();
    showCartPopup(e?.detail?.lineItem, e?.detail?.productString);
  });
};
